module.exports = function(x, options) {
    if(x) { return options.fn(this); }
    return options.inverse(this);
};
